'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import { ArticleSidebarForm } from '@/app/[locale]/blog/_components/ArticleSidebarForm';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import Heading from '@/components/typography/Heading';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import { ARTICLE_SIDEBAR_TEST_IDS } from '@/lib/test-ids';
import { getColorVariant } from '@/utils/colorMapping';
export const ArticleSidebar = t0 => {
  const $ = _c(39);
  const {
    sidebar
  } = t0;
  const t = useTranslations("ArticleSidebar");
  const variant = sidebar?.variant ?? "default";
  let t1;
  let t2;
  let t3;
  if ($[0] !== sidebar?.backgroundColor?.color || $[1] !== sidebar?.image || $[2] !== variant) {
    const bgClassName = variant === "blank" ? "bg-white" : getColorVariant(sidebar?.backgroundColor?.color, "bg", "peach-200");
    t2 = ARTICLE_SIDEBAR_TEST_IDS.COMPONENT;
    t3 = sidebar?.image && <div className={cn("w-full overflow-hidden lg:rounded-b-none lg:rounded-t-xl", bgClassName)}><div className="relative w-full lg:h-37.5 h-45 "><BasicImage component={sidebar?.image} className="lg:object-cover object-contain" fill={true} /></div></div>;
    t1 = cn("rounded-b-xl  gap-4 flex flex-col", bgClassName, variant === "default" && "p-5", sidebar?.image ? "rounded-t-none" : "rounded-t-xl");
    $[0] = sidebar?.backgroundColor?.color;
    $[1] = sidebar?.image;
    $[2] = variant;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = variant === "blank" ? "gap-4" : "gap-3";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("flex flex-col", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== sidebar) {
    t6 = sidebar?.label && <Paragraph fontSize="bodyRegularMedium">{sidebar.label}</Paragraph>;
    $[8] = sidebar;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = variant === "blank" ? "serifMedium" : "headingSmall";
  const t8 = variant === "blank" && "!text-5xl/14";
  let t9;
  if ($[10] !== t8) {
    t9 = cn(t8);
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== sidebar?.title || $[13] !== t) {
    t10 = sidebar?.title ?? t("title");
    $[12] = sidebar?.title;
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7 || $[17] !== t9) {
    t11 = <Heading tag="h2" fontSize={t7} className={t9}>{t10}</Heading>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t6) {
    t12 = <div className="flex flex-col gap-1">{t6}{t11}</div>;
    $[19] = t11;
    $[20] = t6;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== sidebar?.description || $[23] !== variant) {
    t13 = sidebar?.description && <Paragraph fontSize={variant === "blank" ? "bodyRegularLarge" : "bodyRegularMedium"}>{sidebar?.description}</Paragraph>;
    $[22] = sidebar?.description;
    $[23] = variant;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13 || $[27] !== t5) {
    t14 = <div className={t5}>{t12}{t13}</div>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t5;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== sidebar) {
    t15 = <ArticleSidebarForm sidebar={sidebar} />;
    $[29] = sidebar;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t1 || $[32] !== t14 || $[33] !== t15) {
    t16 = <div className={t1}>{t14}{t15}</div>;
    $[31] = t1;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16 || $[36] !== t2 || $[37] !== t3) {
    t17 = <div data-test-id={t2}>{t3}{t16}</div>;
    $[35] = t16;
    $[36] = t2;
    $[37] = t3;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};